const documentAgreementVersions = Object.freeze({
    V1: 1,
    V2: 2,
    V3: 3,
    V4: 4
});

export default documentAgreementVersions;